import { HtmlPageMetaContextProps } from '~/components/HtmlPageMeta/HtmlPageMetaContextProps'
import { ApplicationTrophyDto } from '~/modules/Products/Application/Dtos/ApplicationTrophyDto'
import { ApiTrophyResponseInterface } from '~/modules/Trophies/Application/ApiTrophyResponseInterface'
import {
  GetOrganizerResponseInterface
} from '~/modules/Organizers/Application/GetOrganizer/GetOrganizerResponseInterface'

export interface OrganizerPageViewModel {
  htmlPageMetaContextProps: HtmlPageMetaContextProps
  trophies: ApplicationTrophyDto[]
  featuredTrophy: ApiTrophyResponseInterface | null
  organizerResponse: GetOrganizerResponseInterface
}

export function fromOrganizerPagePropsToViewModel (props: OrganizerPageViewModel): OrganizerPageViewModel {
  return {
    htmlPageMetaContextProps: props.htmlPageMetaContextProps,
    trophies: props.trophies,
    featuredTrophy: props.featuredTrophy,
    organizerResponse: props.organizerResponse,
  }
}
